module.exports = __webpack_public_path__ + "img/Brazil.a6f46ee1.png";